"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_SAVE = exports.STORAGE_LOAD = void 0;
var redux_persistence_1 = require("redux-persistence");
Object.defineProperty(exports, "STORAGE_LOAD", { enumerable: true, get: function () { return redux_persistence_1.LOAD; } });
Object.defineProperty(exports, "STORAGE_SAVE", { enumerable: true, get: function () { return redux_persistence_1.SAVE; } });
//# sourceMappingURL=actions.js.map